import { styled } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";

const CustomizedStaticDateCalendar = styled(DateCalendar)(
    ({ theme }) => `
        .MuiDayCalendar-weekDayLabel {
            width: 36px;
            height: 36px;
        }
        .MuiPickersDay-root {
            width: 40px;
            height: 40px;
        }
    `)

export { CustomizedStaticDateCalendar }